/**
 * Управление активным состоянием нижней навигации
 * и адаптация под мобильные браузеры с адресной строкой
 */
export const initBottomNav = () => {
  const bottomNav = document.querySelector(".bottom-nav");
  const bottomNavLinks = document.querySelectorAll(".bottom-nav__link");
  const sections = document.querySelectorAll("section[id], footer[id]");

  if (!bottomNav || bottomNavLinks.length === 0) {
    return;
  }

  /**
   * Адаптирует позицию навигации под мобильные браузеры
   */
  const adaptBottomNav = () => {
    if (window.innerWidth > 1024) return;

    // Используем visualViewport для определения видимой области
    const viewportHeight = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;
    const windowHeight = window.innerHeight;

    // Вычисляем высоту адресной строки (если она видна)
    const addressBarHeight = Math.max(0, windowHeight - viewportHeight);

    // Базовый отступ 80px + высота адресной строки
    const bottomOffset = 20 + addressBarHeight;
    bottomNav.style.bottom = `${bottomOffset}px`;
  };

  /**
   * Обновляет активное состояние ссылок навигации
   */
  const updateActiveLink = () => {
    if (sections.length === 0) return;

    const scrollPosition = window.scrollY + 250;

    const viewportBottom = window.scrollY + window.innerHeight;
    const docHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );

    // Если доскроллил до низа — активируем последний пункт
    if (viewportBottom >= docHeight - 5) {
      bottomNavLinks.forEach((link) => {
        link.classList.remove("bottom-nav__link--active");
        if (
          link.getAttribute("href") === `#${sections[sections.length - 1].id}`
        ) {
          link.classList.add("bottom-nav__link--active");
        }
      });
      return;
    }

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const sectionId = section.getAttribute("id");

      if (
        scrollPosition >= sectionTop &&
        scrollPosition < sectionTop + sectionHeight
      ) {
        bottomNavLinks.forEach((link) => {
          link.classList.remove("bottom-nav__link--active");
          const href = link.getAttribute("href");
          if (href === `#${sectionId}`) {
            link.classList.add("bottom-nav__link--active");
          }
        });
      }
    });

    // Проверка для главной страницы
    if (scrollPosition < 200) {
      bottomNavLinks.forEach((link) => {
        link.classList.remove("bottom-nav__link--active");
        if (link.getAttribute("href") === "#hero") {
          link.classList.add("bottom-nav__link--active");
        }
      });
    }
  };

  // Адаптация при изменении размера viewport (для мобильных браузеров)
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", adaptBottomNav);
    window.visualViewport.addEventListener("scroll", adaptBottomNav);
  }

  window.addEventListener("resize", adaptBottomNav);
  window.addEventListener("orientationchange", () => {
    setTimeout(adaptBottomNav, 100);
  });

  // Обновление при скролле
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateActiveLink();
        adaptBottomNav();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Инициализация
  adaptBottomNav();
  updateActiveLink();
};
